import React from 'react';

import GraphQL from '~/types/graphql';

import BenefitNameWithIcon from './BenefitNameWithIcon';
import BenefitSectionName from './BenefitSectionName';
import Caption from '~/components/patterns/headings/Caption';
import PlansComparisonTable from '~/components/patterns/pricingPlans/plansComparisonTable/PlansComparisonTable';
import PlansComparisonTableCells, {
	PlansComparisonTableCellsStyle,
} from '~/components/patterns/pricingPlans/plansComparisonTable/PlansComparisonTableCells';
import PlansComparisonTableColumn from '~/components/patterns/pricingPlans/plansComparisonTable/PlansComparisonTableColumn';
import PlansComparisonTableLabels from '~/components/patterns/pricingPlans/plansComparisonTable/PlansComparisonTableLabels';

import useAccountFeaturesAvailability from '~/hooks/useAccountFeaturesAvailability';
import useViewportType from '~/hooks/useViewportType';

import {
	SECTION_ADVANCED_FEATURES,
	SECTION_SERVICES,
} from '~/model/benefits';

import {
	LIST_OF_ALL_PLANS,
	getNewPlanBenefits,
} from '~/model/universal';



const higherCells = [
	SECTION_ADVANCED_FEATURES,
	SECTION_SERVICES,
];



const BenefitsComparison = (props) => {
	const {
		section,
	} = props;

	const accountFeaturesAvailability = useAccountFeaturesAvailability();
	const viewportType = useViewportType();

	if (
		accountFeaturesAvailability === null
	) {
		return null;
	}

	return (
		<PlansComparisonTable
			labels={(
				<PlansComparisonTableLabels
					higher={higherCells.includes(section)}
					labels={getNewPlanBenefits(accountFeaturesAvailability, section).map((item) => (
						<BenefitNameWithIcon
							benefit={item.name}
							hint={item.hint}
							iconType={item.iconType}
							key={item.name}
							section={section}
						/>
					))}
				/>
			)}
			title={(
				<Caption>
					<BenefitSectionName section={section} />
				</Caption>
			)}
		>
			{LIST_OF_ALL_PLANS.v4.toArray().map((plan) => {
				const isEnterprise = plan === GraphQL.AccountPlan.Enterprise;
				const isColumnIndented = isEnterprise && !viewportType.isSmall && !viewportType.isMedium;

				return (
					<PlansComparisonTableColumn
						benefits={(
							<PlansComparisonTableCells
								cells={getNewPlanBenefits(accountFeaturesAvailability, section).map((item) => item.values[plan])}
								higher={higherCells.includes(section)}
								isIndented={isColumnIndented}
								style={isEnterprise ? PlansComparisonTableCellsStyle.Light : PlansComparisonTableCellsStyle.Default}
							/>
						)}
						isEnterprise={isEnterprise}
						isIndented={isColumnIndented}
						key={plan}
					/>
				);
			})}
		</PlansComparisonTable>
	);
};



export default BenefitsComparison;
